import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PdfViewerComponent } from './shared/pdf-viewer/pdf-viewer.component';


const routes: Routes = [
  {
		path: "",
		loadChildren: () => import("./main/main.module").then((m) => m.MainModule),
	},
  {
    path: 'blogPost/pdf/:blogId',
    component: PdfViewerComponent
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
